module.exports = __webpack_public_path__ + "static/6-3b5240a6d08fcca69945db0fed33b19c.jpeg";